import { FormControl } from "@angular/forms";

export {}; // Rend ce fichier en tant que module pour éviter les erreurs

declare global {
  interface String {
    format(...values: string[]): string;
    toCapitalize(): string;
  }
}

String.prototype.format = function (...values: string[]): string {
  return this.replace(/{(\d+)}/g, (match, index) => values[index] || '');
};

String.prototype.toCapitalize = function (): string {
  return this[0].toUpperCase() + this.slice(1);
};

export function capitalize(control: FormControl<string | null>): void {
    control.valueChanges.subscribe((value: string | null) => {
      if (value && value.length > 0) {
        const formatted =
          value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();

        // Mise à jour uniquement si la valeur formatée est différente pour éviter les boucles
        if (value !== formatted) {
          control.setValue(formatted, { emitEvent: false });
        }
      }
    });
  }
